<template>
  <v-container>
    <v-container>
      <v-container>
        <h2>Planejamento de Gerenciamento da Produção</h2>
      </v-container>

      <v-container :class="themeClass" class="d-flex filterCardContainer" style="padding: 0px 12px;">
        <v-tabs v-model="activeTab">
          <v-tab><v-icon>mdi-table</v-icon>PGP</v-tab>
        </v-tabs>
        <v-tabs v-model="activeTab">
          <v-container class="d-flex justify-start flex-wrap" v-if="activeTab === 0">
            <template v-for="(value, key) in filters">
              <v-btn :key="key" v-if="value" style="box-shadow: none; height: 30px; margin: 0px 8px;" small
                @click="clearFilter(key)">
                {{ key }}: {{ value }}
                <v-icon small class="ml-1">mdi-close</v-icon>
              </v-btn>
            </template>
          </v-container>
        </v-tabs>
        <v-hover>
          <v-btn color="#230BC1"
            style="color: #FFF; box-shadow: none; height: 30px; width: 100px; margin-right: 8px; align-self: center"
            @click="savePav">
            <v-icon>mdi-content-save</v-icon>
            Salvar
          </v-btn>
        </v-hover>
        <v-hover>
          <v-btn color="#FFF"
            style="color: #000; border: 1px solid #e1e1e1; box-shadow: none; height: 30px; width: 100px; align-self: center"
            @click="openFilterDialog">
            <v-icon>mdi-tune-vertical</v-icon>
            Filtros
          </v-btn>
        </v-hover>
      </v-container>
      <v-tabs-items v-model="activeTab">
        <v-tab-item>
          <v-tabs-window-item value="PGP">

            <v-data-table :headers="headers" :items="items" :items-per-page-options="customItemsPerPageOptions"
              :footer-props="{
                'items-per-page-options': [50, 100, 200, 500, 1000]
              }" 
              rows-per-page-text="Linhas por página:"
              page-text="{0}-{1} de {2}"
              @update:items-per-page="updateItemsPerPage" @update:page="updatePage" item-key="osItemId" show-expand
              class="elevation-1"
              fixed-header
              :height="items?.length > 9 ? '70vh' : '68vh'">
              <!-- Corpo da tabela -->
              <template v-slot:body="{ items }">
                <tbody v-for="(item, index) in items" :key="index">
                  <tr @click="toggleExpand(item.osItemId)" :style="{ 'background-color': item?.pav?.length > 0 ? '#D3D3D3' : '' }">
                    <!-- Botão de Expandir Linha -->
                    <td>
                      <v-btn v-if="item.pav?.length > 0" icon>

                        <v-icon>

                          {{ expanded.includes(item.osItemId) ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
                        </v-icon>
                        <span style="font-size: 10px;">{{ item?.pav?.filter((item) => item.seq.includes(".")).length
                          }}</span>
                      </v-btn>
                      <span v-else></span>
                    </td>

                    <!-- Botões de adicionar e remover linha -->
                    <td  @click.stop >
                      <v-btn
                        v-if="item.osItemCodigo == 9500000 && !item.editable || item.osItemCodigo == 9100000 && !item.editable"
                        icon color="primary" @click="addRow(item)" even>
                        <v-icon class="actionIcon">mdi-plus</v-icon>
                      </v-btn>
                      <v-btn v-if="item.editable" icon color="error" @click="confirmDelete(item)">
                        <v-icon class="actionIcon">mdi-minus</v-icon>
                      </v-btn>
                    </td>

                    <!-- Colunas -->
                    <td>{{ item.jobCodigo }}</td>
                    <td>{{ item.osCodigo }}</td>
                    <td>{{ item.osItemSequencia }}</td>
                    <td>
                      {{  item.osItemCodigo  }}
                    </td>
                    <!-- <td>{{ item.osItemItemCodigo == 9500000 ?  "Caldeiraria" : item.osItemItemCodigo == 9100000 ? "Serviços" : "Material Cadastrado" }}</td> -->
                    <td class="tdOsItem">
                      <v-textarea style="width: 200px;" v-if="item.editable" v-model="item.osItemDescricao" dense />
                      <span v-else>{{ item.osItemDescricao }}</span>
                    </td>
                    <td>
                      <v-text-field v-if="item.editable" v-model="item.osItemQuantidade" type="number" dense />
                      <span v-else>{{ item.osItemQuantidade }}</span>
                    </td>
                    <td>
                      <v-text-field v-if="item.editable" v-model="item.weight" type="number" dense />
                      <span v-else>
                        {{ item?.pav?.length === 0 ? 0 : item?.pav?.filter(pav => pav.seq.includes('.')).map(pav => Number(pav.totalWeight)).reduce((a, b) => a + b, 0) }}
                      </span>
                    </td>
                    <td>
                      <v-text-field v-if="item.editable" v-model="item.manufacturingDrawing" dense />
                      <span v-else>{{ item.manufacturingDrawing }}</span>
                    </td>
                    <td>
                      <v-text-field v-if="item.editable" v-model="item.assemblyDrawing" dense />
                      <span v-else>{{ item.assemblyDrawing }}</span>
                    </td>
                    <td>{{ item.osItemStatus }}</td>
                    <td>{{ item.pedidoDeCompraCodigo }}</td>
                    <td>{{ item.fornecedorNome }}</td>
                    <td>{{ item.deadline }}</td>
                    <td>{{ item.newDeadline }}</td>
                    <td>
                      <v-select v-if="!item.editable && item.listasDeEmbarque?.length == 0" v-model="item.osItemDestino" @change="trackEditDestino(item)"
                        :items="['Cliente', 'Fornecedor', 'Fabrica']" dense @click.stop />
                      <span v-else>{{ item.osItemDestino }}</span>
                    </td>
                    <!-- Para LEM -->
                    <td style="justify-items: center;text-align: center;">
                      <span v-if="item.listasDeEmbarque?.length === 0" style="text-align: center;">Nenhum</span>
                      <a v-else-if="item.listasDeEmbarque?.length === 1" @click="abrirPackingList('packingListEmb', item.listasDeEmbarque[0].codigo)">{{ item?.listasDeEmbarque[0].codigo }}</a>
                        <a v-else icon small @click="openItemModal(item.listasDeEmbarque, 'LEMs', ['Código'], ['codigo'], 'packingListEmb')" style="display: flex; align-items: center; justify-content: center;">
                        <b>Ver LEMs</b>
                        </a>
                    </td>
                    <!-- Para NF -->
                    <td>
                      <span v-if="item?.notasFiscaisEmitidas?.length === 0">Nenhum</span>
                      <span v-else-if="item?.notasFiscaisEmitidas?.length === 1">{{ item.notasFiscaisEmitidas[0].codigo }}</span>
                      <v-btn v-else icon small @click="openItemModal(item.notasFiscaisEmitidas, 'Notas Fiscais', ['Código', 'Série', 'Número'], ['codigo', 'serie', 'numero'])">
                        <v-icon>mdi-dots-horizontal</v-icon>
                      </v-btn>
                    </td>
                    <td>
                      <span v-if="item?.notasFiscaisEmitidas?.length === 0">Nenhum</span>
                      <span v-else-if="item?.notasFiscaisEmitidas?.length === 1">{{ formatDate(item.notasFiscaisEmitidas[0].dataEmissao) }}</span>
                      <v-btn v-else icon small @click="openItemModal(item.notasFiscaisEmitidas, 'Datas de Embarque', ['Data'], ['dataEmissao'])">
                        <v-icon>mdi-dots-horizontal</v-icon>
                      </v-btn>
                    </td>
                    <!-- Para Romaneio -->
                    <td>
                      <span v-if="item?.romaneios?.length === 0">Nenhum</span>
                      <a v-else-if="item?.romaneios?.length === 1" @click="abrirPackingList('entity/Romaneio', item.romaneios[0].id)">{{ item.romaneios[0].codigo }}</a>
                      <a v-else icon small @click="openItemModal(item.romaneios, 'Romaneios', ['Código'], ['codigo'], 'entity/Romaneio')">
                        <b>Ver Romaneios</b>
                      </a>
                    </td>
                  </tr>

                  <tr v-show="expanded[0] === item.osItemId && pav.seq.includes('.')" v-for="(pav, index) in item?.pav"
                    :key="index">
                    <!-- Botão de Expandir Linha -->
                    <td>
                      <span></span>
                    </td>
                    <!-- Botões de adicionar e remover linha -->
                    <td colspan="1" >
                      <v-btn icon color="error" @click="confirmDelete(pav)">
                        <v-icon class="actionIcon">mdi-minus</v-icon>
                      </v-btn>
                    </td>
                    <!-- Colunas -->
                    <td>{{ item.jobCodigo }}</td>
                    <td>{{ item.osCodigo }}</td>
                    <td>{{ pav.seq }}</td>
                    <td>
                      {{  item.osItemCodigo  }}
                    </td>
                    <!-- <td>{{ item.osItemCodigo == 9500000 ?  "Caldeiraria" : item.osItemCodigo == 9100000 ? "Serviços" : item.osItemCodigo }}</td> -->
                    <td>
                      <v-textarea  v-model="pav.description" dense :rows="descriptionRows" @change="trackEdit(item,pav._id)"/>
                    </td>
                    <td>
                      <v-text-field v-model="pav.qtd" type="number" dense @change="trackEdit(item,pav._id)"/>
                    </td>
                    <td>
                      <v-text-field v-model="pav.totalWeight" type="number" dense @blur="updateTotalWeight(item)"  @change="trackEdit(item,pav._id)" />
                    </td>
                    <td>
                      <v-text-field v-model="pav.manufacturingDrawing" dense @change="trackEdit(item,pav._id)" />
                    </td>
                    <td>
                      <v-text-field v-model="pav.assemblyDrawing" dense @change="trackEdit(item,pav._id)" />
                    </td>
                    <td>{{ pav.itemStatus }}</td>
                    <td>{{ pav.pc }}</td>
                    <td>{{ pav.fornecedorNome }}</td>
                    <td>{{ pav.deadline }}</td>
                    <td>{{ pav.newDeadline }}</td>
                    <td>{{ item.destino }}</td>
                    <!-- Lista de Embarque -->
                    <td style="justify-items: center;text-align: center;">
                      <span v-if="item.listasDeEmbarque?.length === 0" style="text-align: center;">Nenhum</span>
                      <a v-else-if="item.listasDeEmbarque?.length === 1" @click="abrirPackingList('packingListEmb', item.listasDeEmbarque[0].codigo)">{{ item?.listasDeEmbarque[0].codigo }}</a>
                        <a v-else icon small @click="openItemModal(item.listasDeEmbarque, 'LEMs', ['Código'], ['codigo'], 'packingListEmb')" style="display: flex; align-items: center; justify-content: center;">
                        <b>Ver LEMs</b>
                        </a>
                    </td>
                    <td>{{ pav.notasFiscaisEmitidas }}</td>
                    <td>{{ pav.boardingDate }}</td>
                    <td>{{ pav.romaneios }}</td>
                  </tr>

                </tbody>
              </template>
            </v-data-table>

            <v-dialog v-model="filterDialog" max-width="600" class="filterDialog">
              <v-card>
                <v-container class="dialogTitle d-flex justify-sm-space-between align-center">
                  <v-card-title :class="themeClass" class="headline"
                    style="font-size: 16px !important; font-weight: bold;">
                    <v-icon class="text-h6">mdi-tune-vertical</v-icon>
                    Filtros
                  </v-card-title>
                  <div>
                    <v-btn text class="filter_button" @click="clearAllFilters"
                      style="background-color: red; color: #FFF !important; margin-right: 5px;">
                      <v-icon class="text-h6">mdi-trash-can-outline</v-icon>
                      Limpar
                    </v-btn>
                  </div>
                </v-container>
                <v-card-text>
                  <v-form ref="filterForm">
                    <v-row dense>
                      <v-col cols="12" md="6">
                        <v-combobox v-model="filters.jobCodigo" :items="filterJob" label="JOB" dense outlined
                          style="color: #808080" item-text="text" item-value="value"
                          placeholder="Selecione um JOB"></v-combobox>
                      </v-col>
                      <v-col cols="12" md="6">
                        <v-combobox v-model="filters.osCodigo" :items="filterOs" label="Ordem de Serviço" dense outlined
                          style="color: #808080" item-text="text" item-value="value"
                          placeholder="Selecione uma OS"></v-combobox>
                      </v-col>
                      <v-col cols="12" md="6">
                        <v-combobox v-model="filters.osItemStatus" :items="statusOptions" label="Status" dense outlined
                          style="color: #808080" item-text="text" item-value="value"
                          placeholder="Selecione um status"></v-combobox>
                      </v-col>
                      <v-col cols="12" md="6">
                        <v-text-field v-model="filters.osItemDescricao" label="Descrição"
                          placeholder="Digite a descrição" outlined dense></v-text-field>
                      </v-col>


                      <v-col cols="12" md="6">
                        <v-combobox v-model="filters.fornecedorNome" :items="filterSupplier" label="Fornecedor" dense
                          outlined style="color: #808080" item-text="text" item-value="value"
                          placeholder="Selecione um fornecedor"></v-combobox>
                      </v-col>

                      <v-col cols="12" md="6">
                        <v-combobox :items="[]" label="Desenho Fabricação / Posição" dense outlined
                          style="color: #808080" item-text="text" item-value="value"
                          placeholder="Selecione um desenho fabricação / posição"></v-combobox>
                      </v-col>

                      <v-col cols="12" md="6">
                        <v-combobox :items="[]" label="Desenho Montagem / Posição" dense outlined style="color: #808080"
                          item-text="text" item-value="value"
                          placeholder="Selecione um desenho montagem / posição"></v-combobox>
                      </v-col>

                      <v-col cols="12" md="6">
                        <v-combobox v-model="filters.pedidoDeCompraCodigo" :items="filterPedidoDeCompra"
                          label="Pedido de Compra" dense outlined style="color: #808080" item-text="text"
                          item-value="value" placeholder="Selecione um pedido de compra"></v-combobox>
                      </v-col>

                      <v-col cols="12" md="6">
                        <v-combobox v-model="filters.destino" :items="['Cliente','Fornecedor','Fábrica']"
                          label="Destino" dense outlined style="color: #808080" item-text="text" item-value="value"
                          placeholder="Selecione um destino"></v-combobox>
                      </v-col>

                      <v-col cols="12" md="6">
                        <v-combobox label="Lista de Embarque" dense outlined style="color: #808080" item-text="text"
                          item-value="value" placeholder="Selecione uma lista de embarque"></v-combobox>
                      </v-col>


                      <v-col cols="12" md="6">
                        <v-combobox label="Nota Fiscal" dense outlined style="color: #808080" item-text="text"
                          item-value="value" placeholder="Selecione uma nota fiscal"></v-combobox>
                      </v-col>

                      <v-col cols="12" md="6">
                        <v-combobox label="ROM" dense outlined style="color: #808080" item-text="text"
                          item-value="value" placeholder="Selecione um rom"></v-combobox>
                      </v-col>

                      <div style="width: 100%; border: 1px solid #e1e1e1; margin-top: 10px; margin-bottom: 10px;"></div>

                      <v-col cols="12">
                        <h2>Prazo</h2>

                        <v-container class="d-flex justify-sm-space-between pl-0 pb-0">
                          <v-col cols="12" md="6" class="pl-0">
                            <label for="deadlineStart">Início</label>
                            <input type="date" class="filterInputDate" style="color: #808080" name="deadlineStart">
                          </v-col>

                          <v-col cols="12" md="6">
                            <label for="deadlineEnd">Fim</label>
                            <input type="date" class="filterInputDate" style="color: #808080" name="deadlineEnd">
                          </v-col>
                        </v-container>
                      </v-col>

                      <div style="width: 100%; border: 1px solid #e1e1e1; margin-top: 10px; margin-bottom: 10px;"></div>

                      <v-col cols="12">
                        <h2>Novo Prazo</h2>

                        <v-container class="d-flex justify-sm-space-between pl-0 pb-0">
                          <v-col cols="12" md="6" class="pl-0">
                            <label for="newDeadlineStart">Início</label>
                            <input type="date" class="filterInputDate" style="color: #808080" name="newDeadlineStart">
                          </v-col>

                          <v-col cols="12" md="6">
                            <label for="newDeadlineEnd">Fim</label>
                            <input type="date" class="filterInputDate" style="color: #808080" name="newDeadlineEnd">
                          </v-col>
                        </v-container>
                      </v-col>

                      <div style="width: 100%; border: 1px solid #e1e1e1; margin-top: 10px; margin-bottom: 10px;"></div>

                      <v-col cols="12">
                        <h2>Data Embarque</h2>

                        <v-container class="d-flex justify-sm-space-between pl-0 pb-0">
                          <v-col cols="12" md="6" class="pl-0">
                            <label for="newDeadlineStart">Início</label>
                            <input type="date" class="filterInputDate" style="color: #808080" name="newDeadlineStart">
                          </v-col>

                          <v-col cols="12" md="6">
                            <label for="newDeadlineEnd">Fim</label>
                            <input type="date" class="filterInputDate" style="color: #808080" name="newDeadlineEnd">
                          </v-col>
                        </v-container>
                      </v-col>
                    </v-row>
                  </v-form>
                </v-card-text>
              </v-card>
            </v-dialog>

            <!-- Dialog de Exibição de LEM -->
            <v-dialog v-model="itemViewModal" max-width="600px">
              <v-card>
                <v-card-title class="headline">{{ modalTitle }}</v-card-title>
                <v-card-text>
                  <v-simple-table dense>
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th v-for="header in modalHeaders" :key="header">{{ header }}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(item, index) in currentItems" :key="index">
                          <td class="text-center" v-for="field in modalFields" :key="field" style="cursor: pointer;" @click="abrirPackingList(routePath, routePath.includes('entity') ? item['id'] : item[field])">
                            {{ formatModalField(item[field], field) }}
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" text @click="itemViewModal = false">Fechar</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>

            <!-- Dialog de Confirmação de Exclusão -->
            <div v-if="showDeleteModal" class="custom-modal-overlay">
              <v-container class="custom-modal" max-width="500px">
                <v-card>
                  <v-card-title class="headline">
                    Confirmar Exclusão
                  </v-card-title>
                  <v-card-text>
                    Tem certeza de que deseja excluir este item?
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="green darken-1" text @click="cancelDeletion">Cancelar</v-btn>
                    <v-btn color="red darken-1" text @click="confirmDeletion">Excluir</v-btn>
                  </v-card-actions>
                </v-card>
              </v-container>
            </div>

          </v-tabs-window-item>
        </v-tab-item>
        <v-tab-item>
          <v-card>
            <v-card-text>Conteúdo da Página 2</v-card-text>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </v-container>
  </v-container>

</template>

<script>
import axios from 'axios';
import Vue from 'vue';
import moment from 'moment';

export default {
  data() {
    return {
      expanded: [], // Controle da expansão
      showDeleteModal: false,
      itemToDelete: null, 
      activeTab: 0,
      editedItems: new Set(), // Set para armazenar os itens modificados
      deletedIds: [],
      userEmail: '',
      descriptionRows: 1,
      newIds: [],
      singleExpand: false,
      filterOs: [],
      filterJob: [],
      itemsPerPage: 50, // Limite inicial de itens por página
      currentPage: 1, // Página inicial
      filterSupplier: [],
      filterPedidoDeCompra: [],
      filterDescription: [],
      itemViewModal: false,          // Controla a exibição do modal
      modalTitle: '',                // Título dinâmico do modal (ex: "LEMs", "NFs")
      modalHeaders: [],              // Cabeçalhos das colunas da tabela no modal
      modalFields: [],               // Campos dos itens a serem exibidos
      currentItems: [], 
      statusOptions: ['LA', 'SC', 'SF', 'ET', 'EP', 'AA', 'GP', 'RE'],
      filterDialog: false, // Controle do modal de filtros
      filters: {
        destino: "",
        osCodigo: "",
        jobCodigo: "",
        fornecedorNome: "",
        pedidoDeCompraCodigo: "",
        osItemStatus: "",
        osItemDescricao: ""
      },
      tab: null,
      headers: [
        { text: "", value: "data-table-expand" },
        { text: "Ações", value: "actions", sortable: false },
        { text: "JOB", value: "jobCodigo", width: '100px' },
        { text: "OS", value: "osCodigo" },
        { text: "Seq", value: "osItemSequencia" },
        { text: "Cod. Material", value: "osItemCodigo" },
        { text: "Descrição", value: "osItemDescricao", width: "400" },
        { text: "Quantidade", value: "osItemQuantidade" },
        { text: "Peso Total", value: "weight", width: "100" },
        { text: "Desenho Fabricação/Posição", value: "manufacturingDrawing" },
        { text: "Desenho Montagem/Posição", value: "assemblyDrawing" },
        { text: "Status", value: "osItemStatus", width: "150" },
        { text: "PC", value: "pedidoDeCompraCodigo" },
        { text: "Fornecedor", value: "fornecedorNome" },
        { text: "Prazo", value: "deadline" },
        { text: "Novo Prazo", value: "newDeadline" },
        { text: "Destino", value: "destino", width: '150' },
        { text: "LEM", value: "lem", width: 200 },
        { text: "NF", value: "nf", width: 150 },
        { text: "Data Embarque", value: "boardingDate" },
        { text: "ROM", value: "rom", width: 150 },
      ],
      items: [],
      customItemsPerPageOptions: [
        { title: '50', value: 50 },
        { title: '100', value: 100 },
        { title: '150', value: 150 },
        { title: '200', value: 200 }
      ], 
    };
  },
  computed: {
    themeClass() {
      return this.$vuetify.theme.dark ? 'dark-theme' : 'light-theme';
    },
  },
  methods: { 
    abrirPackingList(route, codigo) {
      if (route.includes("entity")) {
        window.open(`${process.env.VUE_APP_URL}/#/${route}?id=${codigo}`, '_blank');
      } else {
        window.open(`${process.env.VUE_APP_URL}/#/${route}?search=${codigo}`, '_blank');
      }
    },
  
    updateTotalWeight(item){
      let sumQuantity = item?.pav?.length == 0 ? item.totalWeight : 0


      item?.pav.map((itemPav, index) => {

        if(itemPav.totalWeight && index != 0){
          sumQuantity += Number(itemPav.totalWeight)
        }
      })

      item.totalWeight = sumQuantity
    },

    trackEdit(item, pavId) {
      console.log(item, pavId)
      item?.pav?.map(pav => {
        if (pav._id === pavId && pavId !== undefined) {
          pav.editado = true;
        }
      });
      this.editedItems.add(item);
      console.log(this.editedItems)
    },
    trackEditDestino(item) {
      let payload = {
        id: item.osItemId,
        destino: item.osItemDestino,
      }

      console.log(payload)

      axios.put(`${process.env.VUE_APP_API_PAV}/api/OSitem`, payload);
    },

    addDescriptionRow(description,itemId, pavId) {
      const item = this.items.find(item => item.id === itemId);
      const pav = item?.pav?.find(pav => pav.id === pavId);
      this.descriptionRows[pav.id] = description / 38;
    },

    toggleExpand(osItemId) {
      if (this.expanded.includes(osItemId)) {
        // Se já estiver, remove da lista (fecha o item)
        this.expanded = this.expanded.filter(item => item !== osItemId);
      } else {
        // Se não estiver, limpa a lista e adiciona o novo item (abre o item)
        this.expanded = [osItemId];
      }
    },

    async getTenanty(){
      const lc = window.localStorage.getItem("user-login");
      const user = JSON.parse(lc);
      this.userEmail = user[1];
    },

    updateItemsPerPage(newLimit) {
      this.itemsPerPage = newLimit;
    },
    updatePage(newPage) {
      this.currentPage = newPage;
    },
    
    // Abre o modal de filtros
    openFilterDialog() {
      this.filterDialog = true;
    },

    // Fecha o modal de filtros
    closeFilterDialog() {
      this.filterDialog = false;
    },

    // Limpa todos os filtros
    clearAllFilters() {
      this.filters = {
        osCodigo: "",
        jobCodigo: "",
        fornecedorNome: "",
        pedidoDeCompraCodigo: "",
        osItemStatus: "",
        osItemSequencia: "",
        osItemDescricao: "",
      };
    },

    // Limpa todos os filtros
    clearFilter(key) {
      this.filters[key] = ""; 
      this.getPGP();  
    },

    openItemModal(items, title, headers, fields, routePath) {
      console.log(items,title,headers,fields, routePath)
      this.currentItems = items;
      this.modalTitle = title;
      this.modalHeaders = headers;
      this.modalFields = fields;
      this.routePath = routePath
      this.itemViewModal = true;
    },

    // Aplica os filtros (exemplo: atualiza itens da tabela)
    applyFilters() {
      this.getPGP();
      this.closeFilterDialog();
    },

    formatNumber(numStr) {
      const [intPart, decPart] = numStr.split(".");
      const paddedInt = intPart.padStart(3, "0");
      return decPart ? `${paddedInt}.${decPart}` : paddedInt;
    },

    // Função para criar uma linha nova a partir da pai (Ex: linha 1, 1.1, 1.2)
    addRow(parentItem) {
      let newSeq;
      if (parentItem.pav?.length > 0) {
        const lastItem = parentItem?.pav.at(-1)
        newSeq = this.generateNextSeq(lastItem.seq);
      } else {
        parentItem.pav = []
        newSeq = this.generateNextSeq(parentItem.osItemSequencia);
      }
      const targetItem = this.items.find(item => item.osItemId === parentItem.osItemId);

      const newItem = {
        seq: this.formatNumber(newSeq).toString(),
        editable: true, // Linhas adicionadas são editáveis
        jobCodigo: parentItem.jobCodigo,
        jobId: parentItem.jobId,
        osDescricao: parentItem.osDescricao,
        pedidoDeCompraId: parentItem.pedidoDeCompraId,
        osCodigo: parentItem.osCodigo,
        osId: parentItem.osId,
        description: '',
        osItemPaiId: parentItem.osItemId, 
        osItemCodigo: parentItem.osItemCodigo,
        qtd: 0,
        totalWeight: 0,
        manufacturingDrawing: parentItem.manufacturingDrawing,
        assemblyDrawing: parentItem.assemblyDrawing,
        itemStatus: parentItem.osItemStatus,
        pedidoDeCompraCodigo: parentItem.pedidoDeCompraCodigo,
        fornecedorId: parentItem.fornecedorId,
        fornecedorNome: parentItem.fornecedorNome,
        deadline: parentItem.deadline,
        newDeadline: parentItem.newDeadline,
        destino: parentItem.destino,
        lem: parentItem.listasDeEmbarque,
        nf: '', //parentItem.notasFiscaisEmitidas,
        boardingDate: parentItem.boardingDate,
        rom: parentItem.romaneios,
        deleted: false
      };
      console.log(newSeq)

      targetItem.pav.push(newItem)
    },
    
    confirmDelete(item) {
      console.log(item)
      this.itemToDelete = item; 
      this.showDeleteModal = true; 
    },

    confirmDeletion() {
      if (this.itemToDelete) {
        console.log(this.itemToDelete)
        this.removeRow(this.itemToDelete);
        this.itemToDelete = null;
      }
      this.showDeleteModal = false; 
    },

    cancelDeletion() {
      this.itemToDelete = null;
      this.showDeleteModal = false; 
    },

    // Função para remover uma linha criada, não funciona para linhas pai
    async removeRow(line) {
      if (!line) {
        console.log("Linha inválida para remoção");
        return;
      }
      try {
        if (line._id) {
          const PutRequest = {
            "_id": line._id,
            "osItemId": line.osItemId,
            "osItemCodigo": line.osItemCodigo,
            "job": line.job,
            "jobCodigo": line.jobCodigo,
            "osCodigo": line.osCodigo,
            "supplier": line.fornecedorId,
            "supplierName": line.fornecedorNome,
            "PC": line.pedidoDeCompraId,
            "pedidoDeCompraCodigo": line.pedidoDeCompraCodigo,
            "os": line.os,
            "seq": line.seq,
            "assemblyDrawing": line.assemblyDrawing || '',
            "drawingReview": "",
            "position": "",
            "manufacturingDrawing": line.manufacturingDrawing || '',
            "manufacturingReview": "",
            "qtd": line.qtd,
            "description": line.description || '',
            "destiny": line.destino,
            "totalWeight": line.totalWeight || 0,
            "rawMaterial": "",
            "preparationCutting": "",
            "boilermakingMachining": "",
            "finishingWelding": "",
            "painting": "",
            "inspectionTests": "",
            "shippingWeight": 0,
            "fullAdvance": 0,
            "osBalance": 0,
            "startManufacturing": "",
            "updateDate": "",
            "responsibleUpdate": "",
            "blackTimeline": "",
            "blackProjectionInspection": "",
            "paintingTimeline": "",
            "paintingProjectionInspection": "",
            "purchaseDeadline": "",
            "rid": "",
            "inspector": "",
            "itemStatus": line.itemStatus,
            "pendencyObservations": "",
            "nf": "",
            "shippingDate": "",
            "createAt": line.createAt,
            "createBy": line.createBy,
            "updateAt":new Date().toISOString(),
            "updateBy":this.userEmail,
            "deleteAt":new Date().toISOString(),
            "deleteBy":this.userEmail,
            "isDeleted":true
          };
          await axios.put(
            `${process.env.VUE_APP_API_PAV}/Api/PAV`,
            [PutRequest]
          ).then(async(res) => {


            let payload = {
              osItemId: line.osItemId,
              jobId: line.job,
              seq: line.seq
            }
            await axios.put(
              `${process.env.VUE_APP_API_PAV}/Api/PAVParent`,
              payload
            );
            Vue.prototype.$notify({
              title: "Deletado com Sucesso!",
              closeOnClick: true,
              duration: 3000,
              positions: "right",
              type: "success",
            });
          });
          // await axios.put(
          //   `https://localhost:3001/Api/PAV`,
          //   [PutRequest]
          // ).then(res => {
          //   Vue.prototype.$notify({
          //     title: "Deletado com Sucesso!",
          //     closeOnClick: true,
          //     duration: 3000,
          //     positions: "right",
          //     type: "success",
          //   });
          // });
          this.items = this.items.map(item => {
            if (item.osItemId === line.osItemPaiId || item.osItemId === line.osItemId) {
              const indexToRemove = item.pav.findIndex(pavItem => pavItem.seq === line.seq);
              console.log('item',item)
              
              if (indexToRemove !== -1) {
                item.pav = [
                  ...item.pav.slice(0, indexToRemove),
                  ...item.pav.slice(indexToRemove + 1)
                ];
              }
            }
            return item;
          });
        } else {
          this.items = this.items.map(item => {
            if (item.osItemId === line.osItemPaiId || item.osItemId === line.osItemId) {
              const indexToRemove = item.pav.findIndex(pavItem => pavItem.seq === line.seq);
              console.log('item',item)
              
              if (indexToRemove !== -1) {
                item.pav = [
                  ...item.pav.slice(0, indexToRemove),
                  ...item.pav.slice(indexToRemove + 1)
                ];
              }
            }
            return item;
          });
        }
      } catch (error) {
        console.error(error)
      }
    },

    // Função para verificar a sequência da nova linha criada
    generateNextSeq(parentSeq) {
      // Divide o parentSeq em partes
      const parts = parentSeq.split('.').map(Number);
      
      if (parts.length === 1) {
        // Se o parentSeq tem apenas um número, adiciona '.1' à sequência
        return `${parentSeq}.1`;
      } else {
        // Caso contrário, incrementa o último número da sequência
        parts[parts.length - 1] += 1;
        return parts.join('.');
      }
    },

    formatDate(dateString) {
      if (!dateString) return 'N/D';
      
      try {
        // Converte a string para objeto Date
        const date = new Date(dateString);
        
        // Verifica se a data é válida
        if (isNaN(date.getTime())) return dateString;
        
        // Formata para 'dd/MM/yyyy HH:mm:ss'
        const day = date.getDate().toString().padStart(2, '0');
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const year = date.getFullYear();
        const hours = date.getHours().toString().padStart(2, '0');
        const minutes = date.getMinutes().toString().padStart(2, '0');
        const seconds = date.getSeconds().toString().padStart(2, '0');
        
        return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
      } catch (e) {
        console.error('Erro ao formatar data:', e);
        return dateString; // Retorna o original se houver erro
      }
    },
    
    // Método para o modal
    formatModalField(value, field) {
      if (!value) return '-';
      
      // Formata datas automaticamente
      if (typeof value === 'string' && (
        field.includes('data') || 
        field.includes('Data') || 
        field.includes('date') ||
        value.includes('T') || 
        value.includes('-')
      )) {
        return this.formatDate(value);
      }
      
      return value;
    },

    async savePav() {
      try {
        console.log('Item a serem CRIADOS:', Array.from(this.editedItems).map((item) => item.pav.filter(item => !item._id)));
        console.log('Item a serem EDITADOS:', Array.from(this.editedItems).map((item) => item.pav.filter(item => item.editado)));

        let cadastrar = Array.from(this.editedItems).map((item) => item.pav.filter(item => !item._id));

        for (const [index, itemOs] of cadastrar.entries()) {
          let osItemPaiId = itemOs.map(item => item.osItemPaiId)[0];
          
          let osItemPai = Array.from(this.editedItems).filter(i => i.osItemId === osItemPaiId)[0];
          

          if (itemOs.length > 0) {
            let createPAV = []
            
            // Chamada para a API para criar os itens
            for (const [index, item] of itemOs.entries()) {
              createPAV.push(item);
            }

              const linhaPai = {
                "osItemId": osItemPai.osItemId,
                "job": osItemPai.jobId,
                "jobCodigo": osItemPai.jobCodigo,
                "osCodigo": osItemPai.osCodigo,
                "osItemCodigo": osItemPai.osItemCodigo,
                "supplier": osItemPai.fornecedorId,
                "supplierNome": osItemPai.fornecedorNome,
                "PC": osItemPai.pedidoDeCompraId,
                "destiny": osItemPai.destino,
                "pedidoDeCompraCOdigo": osItemPai.pedidoDeCompraId,
                "os": osItemPai.osId,
                "seq": osItemPai.osItemSequencia,
                "assemblyDrawing": osItemPai.assemblyDrawing,
                "drawingReview": osItemPai.drawingReview,
                "position": osItemPai.position,
                "manufacturingDrawing": osItemPai.manufacturingDrawing,
                "manufacturingReview": osItemPai.manufacturingReview,
                "qtd": osItemPai.osItemQuantidade,
                "description": osItemPai.osItemDescricao,
                "totalWeight": this.items.filter(item => item.osItemId === osItemPai.osItemId).flatMap(item => item.pav).filter(pav => pav.seq.includes('.')).map(pav => Number(pav.totalWeight)).reduce((a, b) => a + b, 0),
                "rawMaterial": osItemPai.rawMaterial,
                "preparationCutting": osItemPai.preparationCutting,
                "boilermakingMachining": osItemPai.boilermakingMachining,
                "finishingWelding": osItemPai.finishingWelding,
                "painting": osItemPai.painting,
                "inspectionTests": osItemPai.inspectionTests,
                "shippingWeight": osItemPai.shippingWeight,
                "fullAdvance": osItemPai.fullAdvance,
                "osBalance": osItemPai.osBalance,
                "startManufacturing": osItemPai.startManufacturing,
                "updateDate": osItemPai.updateDate,
                "responsibleUpdate": osItemPai.responsibleUpdate,
                "blackTimeline": osItemPai.blackTimeline,
                "blackProjectionInspection": osItemPai.blackProjectionInspection,
                "paintingTimeline": osItemPai.paintingTimeline,
                "paintingProjectionInspection": osItemPai.paintingProjectionInspection,
                "purchaseDeadline": osItemPai.purchaseDeadline,
                "rid": osItemPai.rid,
                "inspector": osItemPai.inspector,
                "itemStatus": osItemPai.osItemStatus,
                "pendencyObservations": osItemPai.pendencyObservations,
                "nf": '', //osItemPai.notasFiscaisEmitidas,
                "shippingDate": osItemPai.shippingDate,
                "createAt": new Date().toISOString(),
                "createBy": this.userEmail,
                "updateAt":null,
                "updateBy":null,
                "deleteAt":null,
                "deleteBy":null,
                "isDeleted":false
              }
            // console.log("item pai: " ,Array.from(this.editedItems).filter(i => i.osItemPaiId == itemOs[0].osItemId));

            await axios.post(
              `${process.env.VUE_APP_API_PAV}/Api/PAV`,
              [linhaPai, ...createPAV]
            );

            Vue.prototype.$notify({
              title: "Salvo com Sucesso!",
              closeOnClick: true,
              duration: 3000,
              positions: "right",
              type: "success",
            });
            await this.getPGP();
            
            let payload = {
              osItemId: linhaPai.osItemId,
              jobId: linhaPai.job,
              seq: linhaPai.seq
            }
            await axios.put(
              `${process.env.VUE_APP_API_PAV}/Api/PAVParent`,
              payload
            );
          }
        }

        let editar = Array.from(this.editedItems).map((item) => item.pav.filter(item => item.editado));
        if (editar.length > 0) {
          // Chamada para a API para editar os itens
          for (const [index, itemOs] of editar.entries()) {

            if (itemOs.length > 0) {
              let editPAV = []
              // Chamada para a API para criar os itens
              for (const [index, item] of itemOs.entries()) {
                delete item.editado
                editPAV.push(item);
              }

              await axios.put(
                `${process.env.VUE_APP_API_PAV}/Api/PAVItem`,
                editPAV
              );

              console.log(cadastrar)
              if(cadastrar[0].length == 0){
                Vue.prototype.$notify({
                  title: "Editado com Sucesso!",
                  closeOnClick: true,
                  duration: 3000,
                  positions: "right",
                  type: "success",
                });
                await this.getPGP();
                
                console.log("PGP atualizado");
              }
              
            }
          }
        }

        this.editedItems = new Set();
      } catch (error) {
        console.error('Error saving PAV:', error);
      }
    },

    // && item.osItemCodigo === '9100000' || !item.osItemSequencia.includes('.') && item.osItemCodigo === '9500000'

    // GET de Linhas da Tabela de PGPf
    async getPGP() {
      const requestData = {
        params: [
          {
            name: "osCodigo",
            dataType: "String",
            value: this.filters.osCodigo
          },
          {
            name: "jobCodigo",
            dataType: "String",
            value: this.filters.jobCodigo
          },
          {
            name: "fornecedorNome",
            dataType: "String",
            value: this.filters.fornecedorNome
          },
          {
            name: "pedidoDeCompraCodigo",
            dataType: "String",
            value: this.filters.pedidoDeCompraCodigo
          },
          {
            name: "osItemStatus",
            dataType: "String",
            value: this.filters.osItemStatus
          },
          {
            name: "osItemSequencia",
            dataType: "String",
            value: this.filters.osItemSequencia
          },
          {
            name: "osItemDescricao",
            dataType: "String",
            value: this.filters.osItemDescricao
          },
          {
            name: "osItemCodigo",
            dataType: "String",
            value: ''
          },
        ],
        viewName: "pgp-visualizar-pgp",
        page: 1,
        limit: 99999999
      };

      try {
        const response = await Vue.prototype.$http.post('/View/run', requestData);

        if (response && response.data) {
          // Transforma os dados, criando um objeto para o item pai e objetos para cada item do pav
          this.items = response.data.data.data.flatMap(item => {
            // Cria o objeto principal (pai)
            
            const parentItem = {
              ...item,
              lem: item.listasDeEmbarque,
              rom: item.romaneios,
              nf: '', //item.notasFiscaisEmitidas,
              editable: false, // Define editable com base no pai
              deleted: false,
              isExpanded: false,
              weight: 0
            };

            return parentItem;

            // Cria objetos separados para cada item do pav
            // const pavItems = item.pav && item.pav.length > 0
            //   ? item.pav.map((pavItem, index) => ({
            //       ...item,        // Copia as propriedades do pai
            //       ...pavItem,     // Sobrescreve com as propriedades do pav
            //       osItemDescricao: pavItem.description,
            //       osItemSequencia: pavItem.seq,
            //       editable: true, // Define editable com base no pav
            //       deleted: false,
            //       weight: 0,
            //     }))
            //   : [];

            // Retorna o pai e os itens pav no mesmo array
            // return [parentItem, ...pavItems];
          });

          // Atualiza os filtros
          this.filterJob = [...new Set(this.items.map(item => item.jobCodigo))];
          this.filterOs = [...new Set(this.items.map(item => item.osCodigo))];
          this.filterSupplier = [...new Set(this.items.map(item => item.fornecedorNome))];
          this.filterPedidoDeCompra = [...new Set(this.items.map(item => item.pedidoDeCompraCodigo))];

        } else {
          console.warn("A resposta da API não contém dados esperados:", response);
        }

      } catch (error) {
        console.error("Erro ao carregar os dados do PGP:", error);
      }
    }
  },
  watch: {
    filters: {
      deep: true,
      handler() {
        this.getPGP();
      }
    },
  },
  created() {
    this.getPGP();
    this.getTenanty();
  }
};
</script>
<style scoped>

  .v-data-table thead th,
  .v-data-table tbody td {
    text-overflow: ellipsis; /* Trunca textos longos */
    white-space: pre-wrap;
  }

  ::-webkit-scrollbar {
    height: 5px !important;
  }

  ::-webkit-scrollbar-thumb {
    background-color: #230BC1 !important;
  }

  .v-data-table--dense > .v-data-table__wrapper > table > thead > tr > th {
    height: 48px;
    border-bottom: 0;
  }

  .v-application--is-ltr .v-data-table > .v-data-table__wrapper > table > thead > tr > th {
    text-align: center !important;
    border-bottom: 0 !important;
  }

  .statusTd {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    height: 53px !important;
  }

  .activeCircle {
    border: 1px solid rgb(197, 167, 34);
    border-radius: 100%; 
    height: 0.5rem; 
    width: 0.5rem; 
    opacity: 80%; 
    background-color: rgb(34 197 94);
  }

  .inactiveCircle {
    border: 1px solid rgb(197, 167, 34);
    border-radius: 100%; 
    height: 0.5rem; 
    width: 0.5rem; 
    opacity: 80%; 
    background-color: #F00;
  }

  .v-application .elevation-1 {
    box-shadow: none !important;
  }

  .mdi-arrow-up::before {
    font-size: 15px !important;
  }

  .mdi-arrow-up::after {
    font-size: 15px !important;
  }

  .actionIcon {
    font-size: 18px !important;
  }

  .v-text-field--outlined fieldset {
    border: 0;
    border-bottom: 1px solid black;
    border-radius: 0;;
  }

  .v-text-field--outlined .v-text-field__slot {
    align-items: end !important;
  }

  .v-text-field .v-input__slot {
    padding: 0 !important;
  }

  .filterInput {
    outline: none;
    border: 1px solid #e1e1e1;
    color: #000;
    border-radius: 4px;
    margin-right: 18px;
    width: 269px;
    padding-left: 10px;
    font-size: 12px;
    height: 40px;
  }

  .theme--dark > .filterInput {
    outline: none;
    border: 1px solid #e1e1e1;
    color: #FFF !important;
    border-radius: 4px;
    margin-right: 18px;
    width: 269px;
    padding-left: 10px;
    font-size: 12px;
    height: 40px;
  }

  .filterInputDate {
    outline: none;
    border: 1px solid #666;
    border-radius: 4px;
    margin-right: 18px;
    width: 269px;
    padding-left: 10px;
    font-size: 12px;
    height: 40px;
  }

  input[type="date"]::-webkit-calendar-picker-indicator {
    cursor: pointer;
    border-radius: 4px;
    margin-right: 2px;
    opacity: 0.6;
    filter: invert(0.8);
  }

  .container {
    margin-right: 0;
    margin-left: 0;
    max-width: 100%;
  }

  .filterDialog {
    margin-top: 280px !important;
  }

  .filterSelect {
    border: 1px solid #e1e1e1;
    width: 270px;
    border-radius: 5px;
    height: 40px;
    padding-left: 10px;
    outline: 0;
  }

  .dialogTitle {
    color: #FFF;
    /* background-color: #230BC1; */
    padding: 0;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
  } 
  
  .theme--dark > .dialogTitle {
    color: #000;
  }

  .filterButton {
    color: #230BC1 !important;
    background-color: #FFF !important;
  }

  #deleteModal {
    align-items: center !important;
    justify-content: center !important;
  }

  .dark-theme {
    background-color: #1E1E1E;
  }

  .v-slide-group__prev, .v-slide-group__prev--disabled {
    display: none !important;
  }

  .v-slide-group__next--disabled, .v-slide-group__prev--disabled {
    display: none !important;
  }

  .dark-theme {
    color: white;
  }

  .light-theme {
    color: #666;
  }

  .custom-modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5); /* Fundo escuro com opacidade reduzida */
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
  }

  /* Estilos para o modal */
  .custom-modal {
    border-radius: 8px;
    width: 500px; /* Largura fixa */
    max-width: 90%; /* Responsividade: ajusta para telas menores */
    padding: 16px;
    z-index: 10000; /* Certifica que o modal está acima do overlay */
  }

  ::v-deep(.v-data-table-header) {
    position: relative;
    z-index: 5 !important;
  }
</style>